<ion-icon *ngIf="!isBepatientIcon" [name]="iconName" [style.color]="color">
</ion-icon>

<ion-icon *ngIf="isBepatientIcon" [src]="iconName" [style.color]="color">
</ion-icon>
